import type { ProfessionDataObject } from '../service';

export type Profession = {
  editable: boolean;
  id: string;
  name: string;
};

export const createProfession = (data: ProfessionDataObject) => ({
  editable: data.editable,
  id: data.id,
  name: data.name,
});
